// src/hooks/useAgent.js
// Invoca edge functions dos agentes do Sprint 1. Um hook por instância — use
// useAgent('briefer') separado de useAgent('decisores') para não disputar estado.

import { useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

const AGENT_ENDPOINTS = {
  briefer: 'agent-company-research-briefer',
  decisores: 'agent-decision-maker-mapper',
  intent: 'agent-apollo-intent-monitor',
  // reuso do que já existe:
  context_harvester: 'agent-apollo-context-harvester',
};

export function useAgent(agentKey) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastResult, setLastResult] = useState(null);

  const endpoint = AGENT_ENDPOINTS[agentKey];
  if (!endpoint) {
    // eslint-disable-next-line no-console
    console.warn(`useAgent: agentKey desconhecido '${agentKey}'`);
  }

  const invoke = useCallback(async (payload) => {
    if (!endpoint) return { ok: false, error: 'agente inválido' };
    setLoading(true);
    setError(null);
    try {
      const { data, error: invErr } = await supabase.functions.invoke(endpoint, {
        body: payload,
      });
      if (invErr) throw new Error(invErr.message || 'Edge function error');
      if (data?.error) throw new Error(data.error);
      setLastResult(data);
      return data;
    } catch (e) {
      const msg = e?.message || String(e);
      setError(msg);
      return { ok: false, error: msg };
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  const reset = useCallback(() => {
    setLastResult(null);
    setError(null);
  }, []);

  return { invoke, loading, error, lastResult, reset };
}
